var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('AppBar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-container',[_c('transition',{attrs:{"name":"route","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }